module.exports = __webpack_public_path__ + "img/republicofmacedonia.1b922c4f.svg";